import { AccountNavigationView } from '@playbooks/components/account/account-navigation-view';

const AccountDropResources = ({ target, onPrev }) => (
	<AccountNavigationView
		title='Resources'
		target={target}
		onBack={onPrev}
		items={[
			{ icon: 'newspaper', href: '/blog', label: 'Blog' },
			{ icon: 'party-horn', href: '/blog/news', label: 'News' },
			{ icon: 'code-commit', href: '/blog/changelog', label: 'Changelog' },
			{ icon: 'engine', href: '/blog/engineering', label: 'Engineering' },
		]}
	/>
);
export { AccountDropResources };
